module.exports = __webpack_public_path__ + "img/IMG_6246.71406e8b.jpg";